module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C96"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_vm._v("TIMELINE OF RELEVANT EVENTS, ACCORDING TO RABBINIC TRADITION")])]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('p', {
    staticClass: "C107"
  }, [_c('img', {
    staticClass: "Image69",
    attrs: {
      "alt": "",
      "src": "img/22_3.png",
      "width": "73%"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-598132e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Timeline_of_Relevant_Events__Acc.vue
// module id = 84
// module chunks = 0